const DividerSchema = {
  title: 'Divider (Semantic UI)',

  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['clearing', 'fitted', 'hidden', 'section'],
    },
  ],

  properties: {
    clearing: { 
      type: 'boolean', 
      title: 'Clearing',
      description: 'Clears the content above the divider',
      default: false,
    },
    fitted: { 
      type: 'boolean', 
      title: 'Fitted',
      description: 'Removes margins from the divider',
      default: false,
    },
    hidden: { 
      type: 'boolean', 
      title: 'Hidden',
      description: 'Hides the divider line',
      default: false,
    },
    section: { 
      type: 'boolean', 
      title: 'Section',
      description: 'Adds greater margins to the divider',
      default: false,
    },
  },

  required: [],
};

export default DividerSchema;